/* eslint complexity: ["error", 5], max-params: ["error", 4], max-depth: ["error", 2], max-statements: ["error", 20] */

'use strict';
import {dispatch} from 'od-modules/secure_store/store';

const actions = require('../../modules/secure_store/actions');

var instance;
var NO_INSURANCE_OFFER_ITEM = 'none';
var RadicalShoppingCart = function() {
    var schema;
    var url = {
        ancillary: Odigeo.Settings.getProperty('ancillariesUrlFormatter')('addancillaries'),
        serviceOptions: Odigeo.Settings.getProperty('serviceOptionsUrlFormatter')('addserviceoption'),
    };
    var product;
    var widgetId;
    var nextPage;

    function configureShoppingCart(prod, wId, bookingId, page) {
        product = prod;
        widgetId = wId;
        nextPage = page;
        schema = {
            'bookingId': bookingId,
            'insuranceOffers': ['none'],
            'nextPage': page.path === 'payment' || page.path === 'checkout_payment' ? 'PAYMENT_PAGE' : 'PRODUCT_PAGE',
            'promotionalCodes': [],
            'removeAncillaryServices': true,
            'serviceOptions': {
                'postsellServiceOptionRequest': {},
            },
            'pageToGo': Odigeo._.isUndefined(page.params) ? page.path : page.params,
        };
    }

    function setAncillary(insuranceId) {
        this.removeAncillary(NO_INSURANCE_OFFER_ITEM, false);

        if (!Odigeo._.isEmpty(insuranceId) && schema.insuranceOffers.indexOf(insuranceId) === -1) {
            schema.insuranceOffers.push(insuranceId);
        }
    }

    function removeAncillary(insuranceId, resetIfEmpty) {
        resetIfEmpty = resetIfEmpty !== false;

        var index = schema.insuranceOffers.indexOf(insuranceId);
        if (index !== -1) {
            schema.insuranceOffers.splice(index, 1);
        }

        if (resetIfEmpty && !schema.insuranceOffers.length) {
            schema.insuranceOffers.push(NO_INSURANCE_OFFER_ITEM);
        }
    }

    function setServiceOption(serviceOptionSelected) {
        schema.serviceOptions = serviceOptionSelected;
    }

    function removeServiceOptions() {
        schema.serviceOptions = {
            'postsellServiceOptionRequest': {},
        };
    }

    function submitProduct() {
        sendAjax(url[product]);
    }

    function sendAjax(url) {
        // eslint-disable-next-line no-restricted-properties
        $.ajax({
            url: url,
            dataType: 'json',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify(schema),
            success: onFetchSuccess,
            error: onFetchError,
        });
    }

    function submitProductPerPage() {
        var fragment = Odigeo.History.getFragment();
        var pageName = Odigeo.History.getPageNameFromFragment();
        var page = fragment.replace(pageName, '').replace(/\//g, '');
        sendAjax(url[product] + '/' + page);
    }

    function onFetchSuccess(response) {
        if (Odigeo._.has(response, 'errors') && Odigeo._.isArray(response.errors) && response.errors.length > 0) {
            Odigeo.trigger('radicalShoppingCart:requestError', response);
        } else {
            if (response.shoppingCartDTO) {
                dispatch({type: actions.SET_SHOPPING_CART, entry: response.shoppingCartDTO});
            }
            Odigeo.trigger(widgetId + ':navigateToNextPage', nextPage);
        }
    }

    function onFetchError(xhr) {
        Odigeo.Model.prototype.afterLoadData(xhr);
    }

    return {
        configureShoppingCart: configureShoppingCart,
        setServiceOption: setServiceOption,
        removeServiceOptions: removeServiceOptions,
        setAncillary: setAncillary,
        removeAncillary: removeAncillary,
        submitProduct: submitProduct,
        submitProductPerPage: submitProductPerPage,
    };
};

export default RadicalShoppingCart;
export const getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new RadicalShoppingCart();
    }

    return instance;
};
